import { render, staticRenderFns } from "./ShowCompanytwo.vue?vue&type=template&id=6a080d1e&scoped=true&"
import script from "./ShowCompanytwo.vue?vue&type=script&lang=js&"
export * from "./ShowCompanytwo.vue?vue&type=script&lang=js&"
import style0 from "./ShowCompanytwo.vue?vue&type=style&index=0&id=6a080d1e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a080d1e",
  null
  
)

export default component.exports